export default {
  data() {
    return {
      auctionItemsPerPage: 3,
      auctionRowStatus: {
        PENDING: 0,
        ONGOING: 1,
        COMPLETED: 2,
        CONFIRMED: 3,
      },
      auctionStatusInfo: {
        0: {
          class: 'pending',
          label: 'Սկսվելու է',
          detailed_label: 'Առաջարկված գին դեռևս չկա',
        },
        1: {
          class: 'live',
          label: 'Ակտիվ',
          detailed_label: 'Աճուրդը ընթացքի մեջ է',
        },
        2: {
          class: 'closed',
          label: 'Պահանջվում է ամփոփում',
          detailed_label: 'Պահանջվում է ամփոփում',
        },
        3: {
          class: 'closed',
          label: 'Հաստատված է',
          detailed_label: 'Հաստատված է',
        }
      }
    }
  }
}
